import {fadeIn, fadeOut} from "./utilities/fade";

function buildChildrenBackLink(wrapper) {
    const li = document.createElement("li");
    const backButton = document.createElement("button");
    const backButtonSpan = document.createElement("span");

    backButton.className = "mobileMenu__backLink";
    backButton.type = "button";
    backButtonSpan.innerText = GLOBALS.tc.back;
    backButton.appendChild(backButtonSpan);

    backButton.addEventListener("click", () => {
        const openParent = backButton.closest(".hasChildren.is-open");
        if (!openParent) return;

        openParent.classList.remove("is-open");

        const toggleBtn = openParent.querySelector("button.nav-toggle");
        if (toggleBtn) toggleBtn.setAttribute("aria-expanded", "false");

        const ul = openParent.querySelector("ul");
        if (ul) {
            ul.scrollTop = 0;
            ul.style.overflow = "";
        }
    });

    li.appendChild(backButton);
    wrapper.prepend(li);
}

function buildChildrenHeader(wrapper, childrenLink) {
    const li = document.createElement("li");
    const isValidLink = childrenLink.tagName === 'A' && childrenLink.href && !childrenLink.href.endsWith('#');

    if (isValidLink) {
        const headerLink = document.createElement("a");
        headerLink.href = childrenLink.href;
        headerLink.innerText = childrenLink.innerText;
        headerLink.className = "mobileMenu__subHeader";
        li.appendChild(headerLink);
    } else {
        const headerDiv = document.createElement("div");
        headerDiv.className = "mobileMenu__subHeader";
        headerDiv.innerText = childrenLink.innerText;
        li.appendChild(headerDiv);
    }

    wrapper.prepend(li);
}

function addClickEventMobileMenuElement(element) {
    const parent = element.closest("li");
    const isInMobileMenu = element.closest('.mobileMenu');
    const childrenList = parent.querySelector("ul, .submenu-container");

    if (!childrenList || !isInMobileMenu) return;

    const mobileMenuBody = document.querySelector('.mobileMenu__body');

    element.addEventListener("click", (e) => {
        const isOpen = parent.classList.contains("is-open");
        const parentUl = element.closest("ul");

        parent.classList.toggle("is-open", !isOpen);
        element.classList.toggle("is-active", !isOpen);

        if (element.tagName === 'BUTTON') {
            element.setAttribute("aria-expanded", !isOpen);
        }

        parentUl.scrollTop = 0;
        parentUl.style.overflow = isOpen ? "" : "hidden";
        mobileMenuBody.scrollTop = 0;

        e.preventDefault();
    });

    parent.classList.add("hasChildren");
    buildChildrenHeader(childrenList, element);
    buildChildrenBackLink(childrenList);
}

export function buildMobileMenu(menu) {
    if (menu) {
        for(let menuNavigation of menu.querySelectorAll(".mobileMenu__navigation")){
            for (let element of menuNavigation.querySelectorAll('a, button.nav-toggle')) {
                addClickEventMobileMenuElement(element);
            }
            for (let activeUl of menuNavigation.querySelectorAll('.is-active,.is-active-tree')) {
                activeUl.classList.add("is-open");
                const toggleBtn = activeUl.querySelector("button.nav-toggle");
                if (toggleBtn) {
                    toggleBtn.setAttribute("aria-expanded", "true");
                }
            }
        }
    }
}

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("is-open");
        toggle.classList.add("is-active");
        document.body.classList.add("is-mobilemenuopen");
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("is-open");
    toggle.classList.remove("is-active");
    document.body.classList.remove("is-mobilemenuopen");
    fadeOut(overlay);
}